import useStatusFilters from "@/composables/v2.1/useStatusFilters";
import { StatusFilterNameType, StatusType } from "@/types/filter.types";
import { reactive } from "@vue/composition-api";

export interface StatusFilterInterface {
    title: string;
    name: StatusFilterNameType;
    query: {
        status: StatusType;
        assignedUserId?: unknown;
        assignedTeamId?: unknown;
    };
}

interface RootState {
    new: StatusFilterInterface;
    team: StatusFilterInterface;
    personal: StatusFilterInterface;
    open: StatusFilterInterface;
    archive: StatusFilterInterface;
}

const state: RootState = reactive({
    new: {
        title: "New",
        name: StatusFilterNameType.NEW,
        query: {
            status: StatusType.OPEN,
            assignedUserId: null,
            assignedTeamId: null,
        },
    },
    team: {
        title: "Team",
        name: StatusFilterNameType.TEAM,
        query: {
            status: StatusType.OPEN,
            assignedTeamId: {
                $notnull: true,
            },
            assignedUserId: {
                $isnull: true,
            },
        },
    },
    personal: {
        title: "Personal",
        name: StatusFilterNameType.PERSONAL,
        query: {
            status: StatusType.OPEN,
            assignedUserId: 0,
        },
    },
    open: {
        title: "Open",
        name: StatusFilterNameType.OPEN,
        query: {
            status: StatusType.OPEN,
            $or: [
                {
                    assignedUserId: {
                        $notnull: true,
                    },
                },
                {
                    assignedTeamId: {
                        $notnull: true,
                    },
                },
            ],
        },
    },
    archive: {
        title: "Archived",
        name: StatusFilterNameType.ARCHIVE,
        query: {
            status: StatusType.CLOSED,
        },
    },
});

export default function useMessagingStatusFilters() {
    return useStatusFilters(state);
}
